import {createContext} from 'react'

export const NotificationContext = createContext({
  modalOpen: false,
  setModalOpen: () => {
  },
  gridRowCount: 0,
  setGridRowCount: () => {
  },
  gridCurrentPage: 1,
  setGridCurrentPage: () => {
  },
  notifications: [],
  setNotifications: () => {
  },
  notification: {
    "id": null,
    "user_id": null,
    "create_date": "",
    "title": "",
    "description": "",
    "attachment": null,
    "metadata": "",
    "email": "",
    "email_status": null,
    "email_sent_at": "",
    "sms": "",
    "sms_status": null,
    "sms_sent_at": "",
    "push": "",
    "push_status": "",
    "push_sent_at": "",
    "status": ""
  },
  setNotification: () => {
  },
  lastDataRefresh: Date.now(),
  setLastDataRefresh: () => {
  }
})